import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dialog } from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';

import {
	closeThankyouDialog
} from './MutualAidActions';

function ThankyouDialog({textValue="mutualAid.shareBenchmarkThanks"}) {
	
	const dispatch = useDispatch();
	const isContributeThankyouDialogOpen = useSelector((state) => state.mutualAid.isThankyouDialogOpen);
	
	function closeDialog() {
		dispatch(closeThankyouDialog())
	}
	
	
	return (
		<Dialog
			autoFocus={true}
			canEscapeKeyClose={true}
			canOutsideClickClose={true}
			enforceFocus={true}
			isOpen={isContributeThankyouDialogOpen}
			usePortal= {true}
			onClose={closeDialog}
		>
			<div style={{padding: '20px'}}>
				<Translate value={textValue} />
			</div>
		</Dialog>
	)
}

export default ThankyouDialog;